module.exports = __webpack_public_path__ + "fonts/figtree-latin-italic-300-900.woff2";